import { Dialog, DialogContent } from "@/components/ui/dialog";
import { FilePublishButton } from "@/panes/file-record-detail/FilePublishButton";
import type { FileRecord } from "@cohesive/api-client";

export function PublishFileRecordDialog({
  record,
  onClose,
  onSuccess,
}: {
  record: FileRecord;
  onClose: () => void;
  onSuccess: () => void;
}) {
  return (
    <Dialog
      open
      onOpenChange={(open) => {
        if (!open) onClose();
      }}
    >
      {/* Width is enforced belt-and-braces: the max-w cap holds even when a
          re-render race lets the base w-full through, and overflow-x-hidden
          keeps an unbreakable filename or URL from shifting the centered
          dialog — the inner panel's min-w-0/truncate rules then engage
          exactly as they do in the pane. */}
      <DialogContent className="w-[360px] max-w-[min(360px,calc(100vw-2rem))] gap-0 overflow-x-hidden border dark:border-white/[0.08] p-2">
        <FilePublishButton
          record={record}
          embeddedPanel
          onEmbeddedClose={onClose}
          onEmbeddedSuccess={onSuccess}
        />
      </DialogContent>
    </Dialog>
  );
}
